import { CreateFileInput } from "../../backend/generated/create-file-input";
import { File } from "../../backend/generated/file-model";
import { GenerateUploadSignedUrlInput } from "../../backend/generated/generate-upload-signed-url-input";
import { MimeTypes } from "../../backend/types/utils";
import { prune } from "../../utils/utility";
import { validateRequiredNotDefault } from "../../utils/validation";

export class FileManageable extends File {
  constructor(obj: any) {
    super();

    obj && Object.assign(
      this,
      prune(obj)
    );
  }

  static default(): any {
    return { ...new File() }
  }
}

export class CreateFileManageable extends CreateFileInput {
  constructor(obj?: any) {
    super();
    if (obj) {
      obj && Object.assign(
        this,
        CreateFileManageable.default(),
        prune(obj)
      );
    } else {
      Object.assign(
        this,
        CreateFileManageable.default()
      );
    }
  }

  static readonly required = { id: true };

  static default(): any {
    return { ...new CreateFileInput() }
  }

  validate(keys: Array<string>): any {
    return validateRequiredNotDefault(
      {},
      CreateFileManageable.required,
      this,
      CreateFileManageable.default(),
      keys
    );
  }

  serialize(): any {
    return this;
  }
}

export class GenerateSignedUrlManageable extends GenerateUploadSignedUrlInput {
  constructor(obj?: any) {
    super();

    obj && Object.assign(
      this,
      prune(obj)
    );
  }

  static readonly required = { mimeTypes: true };

  static default(): any {
    return { ...new GenerateUploadSignedUrlInput() }
  }

  validate(keys: Array<string>): any {
    return validateRequiredNotDefault(
      {},
      CreateFileManageable.required,
      this,
      CreateFileManageable.default(),
      keys
    );
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    data.mimeTypes = this.mimeTypes.map((mimeType: string) => {
      const entry = Object.entries(MimeTypes).find((entry: any) => entry[1] === mimeType);
      return entry ? entry[0] : '';
    });

    return data;
  }
}

